import { 
    GET_PAGO_RECEPCIONADO,
    GET_CONFIG_FORM10,
    GET_MONEDAS,
    GET_PERSONA,
    POST_LEGALIZAR_PAGO
 
} from '../types';

export default function legalizacionPagoReducer(state = {}, action) {
    switch (action.type) {
        case GET_PAGO_RECEPCIONADO:
            return { ...state, pagoRecepcionado:action.payload }      
        case GET_CONFIG_FORM10:
            return { ...state, cfg_form10:action.payload }      
        case GET_MONEDAS:
            return { ...state, monedas:action.payload }      
        case GET_PERSONA:
            return { ...state, persona:action.payload }      
        case POST_LEGALIZAR_PAGO:
            return { ...state, respuestaPostLegaliza:action.payload }      
       
        default:
            return state
    }
}